export const updateObject = (oldObject, updatedProperties) => {
  return {
    ...oldObject,
    ...updatedProperties,
  };
};

export const checkValidity = (value, rules) => {
  console.log('checkValidity===value', value);
  console.log('checkValidity===rules', rules);
  let isValid = true;
  let errorMsg = null;

  if (!rules) {
    return { isValid: isValid, errorMsg: errorMsg };  //eslint-disable-line
  }

  if (rules.required) {
    isValid = value.trim() !== '' && isValid;
    errorMsg = 'Missing';
  }

  if (rules.minLength) {
    isValid = value.length >= rules.minLength && isValid;
    errorMsg = `Minimum no. of characters should be ${rules.minLength}`;
  }

  if (rules.maxLength) {
    isValid = value.length <= rules.maxLength && isValid;
    errorMsg = `No. of characters should not exceed ${rules.maxLength}`;
  }

  if (rules.isEmail) {
    const pattern = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    isValid = pattern.test(value) && isValid;
    errorMsg = 'Email format incorrect';
  }

  if (rules.isNumeric) {
    const pattern = /^\d+$/;
    isValid = pattern.test(value) && isValid;
    errorMsg = 'Enter only numeric value';
  }

  if (rules.isValueRequired) {
    isValid = value !== null;
    errorMsg = 'Missing';
  }

  if (rules.noSpacesAllowed) {
    const arr = value.trim().split(' ');
    if (arr.length > 1) {
      isValid = false;
      errorMsg = 'Enter only one word';
    }
  }

  return { isValid: isValid, errorMsg: errorMsg };  //eslint-disable-line
};


export const changeInputHandler = (event, inputs, field) => {
  console.log('changeInputHandler===event', event);
  console.log('changeInputHandler===inputs', inputs);
  console.log('changeInputHandler===field', field);
  let value = null;
  let file = null;
  try {
    event.persist();
    if (event.target.files) {
      value = event.target.value;  // eslint-disable-line
      file = event.target.files[0]; // eslint-disable-line
    } else {
      value = event.target.value;  // eslint-disable-line
    }
  } catch (error) {
    value = event;
  }
  console.log('changeInputHandler===value', value);
  console.log('changeInputHandler===file', file);
  const validity = checkValidity(value, inputs[field].validation);
  console.log('utility===validity',validity);
  const validationRegex = /[^a-z0-9$&+,:;=?@#|'<>.^*()%!-_~`{}\s]/gi;
  return {
    [field]: updateObject(inputs[field], {
      value:  (typeof value === 'string') ? value.replace(validationRegex, "") : value, // eslint-disable-line
      valid: validity.isValid,
      errorMsg: validity.errorMsg,
      touched: true,
      file: file,  // eslint-disable-line
    }),
  };
};


export const handleFormSubmit = (event, inputs) => {
  console.log('utility===handleFormSubmit===event', event);
  console.log('utility===handleFormSubmit===inputs', inputs);
  event.preventDefault();

  const result = {
    fields: {},
    formError: false,
    inputs: null,
  };

  for (const key in inputs) {
    if (!inputs[key].valid) {
      const updatedInput = updateObject(
        inputs, {
          [key]: updateObject(inputs[key], {
            touched: true,
          }),
        },
      );
      result.formError = true;
      result.inputs = updatedInput;
      break;
    }
    if (inputs[key].file) {
      result.fields[key] = inputs[key].file;
    } else {
      result.fields[key] = inputs[key].value;
    }
  }
  console.log('utility===handleFormSubmit===result', result);
  return result;
};


export const updateFieldErrorsHandler = (inputs, errorData) => {
  Object.keys(errorData).map((key) => {
    const input = inputs[key];
    if (input) {
      input.valid = false;
      input.touched = true;
      input.errorMsg = errorData[key][0];  // eslint-disable-line
      inputs[key] = input;  // eslint-disable-line
    }
    return null;
  });
  return inputs;
};



// WEBPACK FOOTER //
// ./src/common/utility.js